import React from 'react'
import ColorSystemPage from './ColorSystemPage'
import '../styles/index.scss'

const ColorSystemContainer = () => {
    return (
        <div className='ColorSystemContainer'>
            <ColorSystemPage />
        </div>
    )
}

export default ColorSystemContainer